export default __webpack_public_path__ + "img/80caf7145de3ad9625b3be1e2615a8db.svg";